// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"11d5a115","667":"e0b173b1"}[chunkId] + ".chunk.js";
};